import { toast, type ExternalToast } from 'sonner';

/* What used to be window.alert() (D8). Success messages pass on their own; failures, errors and
   "Please select…" messages stay until the user closes them; anything else is a plain toast. */

export const notifySuccess = (message: string) => toast.success(message);

/** A failure that stays until it is closed. `options` can give it an `id` (one toast, raised again in place) or an `action`. */
export const notifyError = (message: string, options?: ExternalToast) => toast.error(message, { duration: Infinity, closeButton: true, ...options });

export const notify = (message: string) => toast(message);

/** Takes down the notice raised with this `id`, if it is showing. */
export const dismissNotice = (id: string | number) => toast.dismiss(id);
